import { render, staticRenderFns } from "./addinvoice.vue?vue&type=template&id=182c6c7a&scoped=true&"
import script from "./addinvoice.vue?vue&type=script&lang=js&"
export * from "./addinvoice.vue?vue&type=script&lang=js&"
import style0 from "./addinvoice.vue?vue&type=style&index=0&id=182c6c7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c6c7a",
  null
  
)

export default component.exports